import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { GoMaterialModule } from '@go-modules/go-material.module';
import { CollectionItemViewerComponent } from './collection-item-viewer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMediaThumbnailModule } from '@go-modules/components/media-thumbnail/media-thumbnail.module';
import { ShareLibraryItemDialogModule } from '@go-modules/components/dialogs/share-library-item-dialog/share-library-item-dialog.module';
import { InvalidEmailsErrorDialogModule } from '@go-modules/components/dialogs/invalid-emails-error-dialog/invalid-emails-error-dialog.module';
import { PreviewMarkerSetDialogModule } from '@go-modules/components/dialogs/preview-marker-set-dialog/preview-marker-set-dialog.module';
import { MarkerSetDialogModule } from '@go-modules/components/dialogs/marker-set-dialog/marker-set-dialog.module';
import {
	OptionalDatePickerDialogModule
} from '@go-modules/components/dialogs/optional-date-picker-dialog/optional-date-picker-dialog.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';

@NgModule({
	imports: [
		CommonModule,
		TranslateModule,
		GoMaterialModule,
		NgxMediaThumbnailModule,
		FormsModule,
		ReactiveFormsModule,
		ShareLibraryItemDialogModule,
		InvalidEmailsErrorDialogModule,
		PreviewMarkerSetDialogModule,
		MarkerSetDialogModule,
		OptionalDatePickerDialogModule,
		MatProgressBarModule
	],
	declarations: [
		CollectionItemViewerComponent
	],
	exports: [
		CollectionItemViewerComponent
	]
})
export class CollectionItemViewerModule {}
